// extracted by mini-css-extract-plugin
export var results = "style-module--results--de135";
export var results__description = "style-module--results__description--140e2";
export var results__item = "style-module--results__item--eca45";
export var results__list = "style-module--results__list--dbefe";
export var results__title = "style-module--results__title--1b73c";